import { render } from "./PCParteProduccionNumeroTrabajadores.vue?vue&type=template&id=5f68ae56&scoped=true"
import script from "./PCParteProduccionNumeroTrabajadores.vue?vue&type=script&lang=js"
export * from "./PCParteProduccionNumeroTrabajadores.vue?vue&type=script&lang=js"

import "./PCParteProduccionNumeroTrabajadores.vue?vue&type=style&index=0&id=5f68ae56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f68ae56"]])

export default __exports__